jQuery(document).ready(($) => {

	$('input#reception.form-check-input').change(function() {
		if ($(this).is(':checked')) {
			$(this).closest('.mb-3').next('.allergy').show();
		} else {
			$(this).closest('.mb-3').next('.allergy').hide();
		}
	});

});
